import React, {Component} from 'react';
import {Table, Button, Tooltip} from 'antd';

import _ from 'lodash';

import PropTypes from "prop-types";
import * as d3 from "d3";

import * as fileUtils from '../../utils/file-utils';
import './index.css';


class DataTable extends Component {

  render() {
    const colors = ['#222', '#3d1c3d', '#6e246e', '#a520a5', '#e00de0'];
    const colorScale = d3.scaleQuantile()
      .domain([0, 50, 75, 90, 100])
      .range(colors);

    const data = this.props.data;
    const percentiles = this.props.percentiles;
    const dimensions = this.props.dimensions;

    const getFilters = data => {
      const specs = _.uniq(_.map(data, 'category'));

      return _.map(specs, s => {
        return {
          text: s,
          value: s
        }
      })
    };

    const nameRenderer = (value, object) => {
      let color = 'inherit';

      if (object.key === this.props.dimX) {
        color = '#de3434'
      }
      else if (object.key === this.props.dimY) {
        color = '#0f8ee9'
      }

      return {
        children: value,
        props: {
          style: {
            fontWeight: color === 'inherit' ? 400 : 600,
            color: color
          }
        }
      }
    };

    const ordinalSuffixes = ['th', 'st', 'nd', 'rd'];

    const ordinalSuffix = number => {
      const value = number % 100;

      return ordinalSuffixes[(value - 20) % 10] || ordinalSuffixes[value] || ordinalSuffixes[0];
    };

    const percentileRender = (dim, year) => (value, object) => {

      const percentile = _.get(object, dim);

      const tooltip = <div>
        <h4>{object.county} - {year}</h4>
        <small>
          <div className="description">{object.description}</div>
          <b className="blue">County Value : </b><i>{value}</i><br/>
          <b className="purple">National Percentile : </b><i>{percentile}{ordinalSuffix(percentile)}</i><br/>
          <b>National Average : </b><i>{getYearValueTest(this.props.national, object.key, year)}</i><br/>
          <b>{this.props.state.sn || 'State'} Average : </b><i>{getYearValueTest(this.props.state, object.key, year)}</i><br/>
        </small>
      </div>;

      return {
        children: <Tooltip placement={year === 2007 ? 'left' : 'top'} title={tooltip}>{value}</Tooltip>,
        props: {
          style: {
            background: colorScale(percentile)
          }
        }
      };
    };

    function getYearValueTest(row, prop, year) {
      const yearIndex = 2015 - (year || 2015);
      console.log(row, prop, year, _.get(row, [prop, yearIndex], 0))

      return _.get(row, [prop, yearIndex], 0);
    }

    function getYearValue(row, prop, year) {
      const yearIndex = 2015 - (year || 2015);
      return _.get(row, [prop, yearIndex], 0);
    }

    const rows = _.map(dimensions, d => {
      return {
        key: d.field,
        county: this.props.county,
        dimension: d.label,
        category: d.category,
        description: d.desc,
        year07: getYearValue(data, d.field, 2007),
        year08: getYearValue(data, d.field, 2008),
        year09: getYearValue(data, d.field, 2009),
        year10: getYearValue(data, d.field, 2010),
        year11: getYearValue(data, d.field, 2011),
        year12: getYearValue(data, d.field, 2012),
        year13: getYearValue(data, d.field, 2013),
        year14: getYearValue(data, d.field, 2014),
        year15: getYearValue(data, d.field, 2015),
        percentile07: getYearValue(percentiles, d.field, 2007),
        percentile08: getYearValue(percentiles, d.field, 2008),
        percentile09: getYearValue(percentiles, d.field, 2009),
        percentile10: getYearValue(percentiles, d.field, 2010),
        percentile11: getYearValue(percentiles, d.field, 2011),
        percentile12: getYearValue(percentiles, d.field, 2012),
        percentile13: getYearValue(percentiles, d.field, 2013),
        percentile14: getYearValue(percentiles, d.field, 2014),
        percentile15: getYearValue(percentiles, d.field, 2015),
      }
    });

    const handleDownload = () => {
      const filename = _.kebabCase(this.props.county + ' Health Dimensions') + '.csv';
      const csvText = fileUtils.createCsv(rows);

      fileUtils.saveTextFile(csvText, filename);
    };

    const columns = [{
      title: 'Dimension',
      dataIndex: 'dimension',
      key: 'dimension',
      filters: getFilters(rows),
      onFilter: (value, record) => record.category === value,
      render: nameRenderer
    }, {
      title: '2015',
      dataIndex: 'year15',
      key: 'year15',
      render: percentileRender('percentile15', 2015),
      sorter: (a, b) => a.percentile15 - b.percentile15
    }, {
      title: '2014',
      dataIndex: 'year14',
      key: 'year14',
      render: percentileRender('percentile14', 2014),
      sorter: (a, b) => a.percentile14 - b.percentile14
    }, {
      title: '2013',
      dataIndex: 'year13',
      key: 'year13',
      render: percentileRender('percentile13', 2013),
      sorter: (a, b) => a.percentile13 - b.percentile13
    }, {
      title: '2012',
      dataIndex: 'year12',
      key: 'year12',
      render: percentileRender('percentile12', 2012),
      sorter: (a, b) => a.percentile12 - b.percentile12
    }, {
      title: '2011',
      dataIndex: 'year11',
      key: 'year11',
      render: percentileRender('percentile11', 2011),
      sorter: (a, b) => a.percentile11 - b.percentile11
    }, {
      title: '2010',
      dataIndex: 'year10',
      key: 'year10',
      render: percentileRender('percentile10', 2010),
      sorter: (a, b) => a.percentile10 - b.percentile10
    }, {
      title: '2009',
      dataIndex: 'year09',
      key: 'year09',
      render: percentileRender('percentile09', 2009),
      sorter: (a, b) => a.percentile09 - b.percentile09
    }, {
      title: '2008',
      dataIndex: 'year08',
      key: 'year08',
      render: percentileRender('percentile08', 2008),
      sorter: (a, b) => a.percentile08 - b.percentile08
    }, {
      title: '2007',
      dataIndex: 'year07',
      key: 'year07',
      render: percentileRender('percentile07', 2007),
      sorter: (a, b) => a.percentile07 - b.percentile07
    }
    ];

    return (
      <div className="DataTable">
        <Table
          rowKey="npi"
          size="middle"
          bordered={false}
          pagination={{
            defaultPageSize: 20,
            pageSizeOptions: ['10', '20', '50'],
            showSizeChanger: true
          }}
          showHeader={true}
          columns={columns}
          dataSource={rows}/>

        <div className="dl-button">
          <Button type="primary" icon="download" size="small" ghost onClick={handleDownload}>Download</Button>
        </div>
      </div>
    );
  }
}

DataTable.propTypes = {
  county: PropTypes.string,
  data: PropTypes.object,
  percentiles: PropTypes.object,
  state: PropTypes.object,
  national: PropTypes.object,
  dimensions: PropTypes.array,
  dimX: PropTypes.string,
  dimY: PropTypes.string
};

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/DataTable/index.js